export default {
  routes: [
    {
      name: 'operations',
      path: '/operations',
      beforeEnter: (to, from, next) => {
        if (to.query.tab === 'add') {
          const { tab, ...query } = to.query
          next({ path: '/operations/add', query })
        } else {
          next()
        }
      },
      component: () => import('./views/TheOperations.vue'),

    },

    {
      name: 'operation',
      path: '/operations/:uuid',
      component: () => import('./views/TheOperation.vue'),
    }
  ]
}
